// extracted by mini-css-extract-plugin
module.exports = {"container":"tournamentName__container___3p-ro","tournamentName":"tournamentName__tournamentName___1V3DJ"};